import Vue from "vue";
import FloatingVue from "floating-vue";

Vue.use(FloatingVue, {
  themes: {
    "context-menu": {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover", "focus"],
      placement: "auto",
      html: true,
      delay: {
        show: 0,
        hide: 400,
      },
    },
    "bn-tooltip": {
      $extend: "tooltip",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover", "focus"],
      placement: "auto",
      html: true,
      $resetCss: true,
    },
    "sidebar-tooltip": {
      $extend: "tooltip",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover", "focus"],
      placement: "right",
      distance: 8,
      delay: {
        show: 0,
        hide: 0,
      },
    },
  },
});
